export default __webpack_public_path__ + "static/media/light-arrow_right_disabled_dark.9642cfca.svg";